import { render, staticRenderFns } from "./subCategorySlider.vue?vue&type=template&id=2c480a6a&scoped=true"
import script from "./subCategorySlider.vue?vue&type=script&lang=js"
export * from "./subCategorySlider.vue?vue&type=script&lang=js"
import style0 from "./subCategorySlider.vue?vue&type=style&index=0&id=2c480a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c480a6a",
  null
  
)

export default component.exports